export default __webpack_public_path__ + "static/Sprint2_RiskManagement_RiskAssessmentProcess_060722-78253d8c0e1d4a5c9dd2e327744a2164.mp4";